import { ILinks } from "../../interfaces/LinksInterface";

export const links: ILinks[] = [
  {
    to: "/",
    text: "Home",
    id: 1,
  },
  {
    to: "/about",
    text: "About",
    id: 2,
  },
  {
    to: "/projects",
    text: "Projects",
    id: 3,
  },
  {
    to: "/contact",
    text: "Contact",
    id: 4,
  },
];

export const NavBarLinks = [
  {
    to: "/",
    text: "Home",
    id: 1,
  },
  {
    to: "/about",
    text: "About",
    id: 2,
  },
  {
    to: "/projects",
    text: "Projects",
    id: 3,
  },
  {
    to: "/contact",
    text: "Contact",
    id: 4,
  },
];
